module.exports = __webpack_public_path__ + "static/media/A7S02634.358f258a.jpg";